import { pageNumber, startPath } from "../view-models/app-signals";
import { pageCount } from "../view-models/page-signals";

export class BookmarkLocator {
  // public id: string;
  // public page?: number | null;

  constructor(page) {
    this.href = startPath(); // pdf starting path
    this.type = "application/pdf";
    this.page = page;
    const count = pageCount();
    this.locations = {
      // Before the page count is known page / count would be NaN or
      // Infinity, which breaks the progression sort of bookmarks.
      progression: count > 0 ? Math.min(Math.max(page / count, 0), 1) : 0,
      position: page - 1,
    };
    this.title = `Page ${this.page}`;
    this.id = window.crypto.randomUUID();
  }
}

export function currentLocation() {
  return new BookmarkLocator(pageNumber());
}

export function pageToLocator(page) {
  return new BookmarkLocator(page);
}
